import { Controller } from "@hotwired/stimulus";

// Formulaire de devis en trois étapes. Version statique : la dernière étape
// prépare un email à l'adresse de SXN Labs. La tranche S2 remplacera l'email par
// un envoi à Argos (sxnlabs/site-internet-brest#2).
export default class extends Controller {
  static targets = ["step", "label", "progress", "progressWrap", "back", "next", "nextLabel", "done", "actions"];
  static values = { email: String };

  connect() {
    // `required` sert la version sans JavaScript, où tout s'affiche d'un coup.
    // Ici les étapes masquées bloqueraient l'envoi : le contrôleur valide lui-même.
    this.element.noValidate = true;
    this.current = 0;
    this.progressWrapTarget.hidden = false;
    this.render();
  }

  back() {
    this.current = Math.max(0, this.current - 1);
    this.render();
    this.focusStep();
  }

  refresh() {
    this.nextTarget.disabled = !this.isComplete();
  }

  submit(event) {
    event.preventDefault();
    if (!this.isComplete()) return;

    if (this.current < this.stepTargets.length - 1) {
      this.current += 1;
      this.render();
      this.focusStep();
      return;
    }

    window.location.href = this.mailtoUrl();
    this.stepTargets.forEach((step) => { step.hidden = true; });
    this.actionsTarget.hidden = true;
    this.doneTarget.hidden = false;
    this.progressTarget.style.width = "100%";
    this.labelTarget.textContent = "Prête à envoyer";
    this.doneTarget.focus();
  }

  render() {
    const last = this.stepTargets.length - 1;
    this.stepTargets.forEach((step, index) => { step.hidden = index !== this.current; });
    this.backTarget.hidden = this.current === 0;
    this.progressTarget.style.width = `${Math.round(((this.current + 1) / this.stepTargets.length) * 100)}%`;
    this.labelTarget.textContent = `Étape ${this.current + 1} sur ${this.stepTargets.length}`;
    this.nextLabelTarget.textContent = this.current === last ? "Recevoir mon devis" : "Continuer";
    this.refresh();
  }

  focusStep() {
    this.stepTargets[this.current].querySelector("input, textarea")?.focus({ preventScroll: true });
  }

  isComplete() {
    const step = this.stepTargets[this.current];
    if (this.current < this.stepTargets.length - 1) return !!step.querySelector("input:checked");

    const value = (name) => this.element.elements[name].value.trim();
    const emailOk = /.+@.+\..+/.test(value("email"));
    const phoneOk = value("telephone").replace(/\D/g, "").length >= 10;
    return value("nom") !== "" && (emailOk || phoneOk);
  }

  mailtoUrl() {
    const value = (name) => this.element.elements[name].value.trim();
    const lines = [
      `Projet : ${value("projet")}`,
      `Budget : ${value("budget")}`,
      `Nom : ${value("nom")}`,
      `Entreprise : ${value("entreprise") || "non précisée"}`,
      `Email : ${value("email") || "non précisé"}`,
      `Téléphone : ${value("telephone") || "non précisé"}`,
      "",
      value("message"),
    ];
    const subject = `Demande de devis : ${value("projet")}`;
    return `mailto:${this.emailValue}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join("\n"))}`;
  }
}
